import { useMemo } from 'react'

import { SelectMasterTranslator } from 'src/translators'
import { useGetSelectMastersQuery } from 'src/types/generated'

export const useGetSelectMasters = ({ projectId }: { projectId: string }) => {
  const { loading, data, error, refetch } = useGetSelectMastersQuery({ variables: { projectId } })

  return {
    loading,
    selectMasters: useMemo(
      () =>
        data && data.selectMasters.selectMasters
          ? SelectMasterTranslator.toEntities({
              projectId,
              responses: data.selectMasters.selectMasters,
            })
          : [],
      [data, projectId]
    ),
    error,
    refetch,
  }
}
